
import { ResizeObserver } from 'resize-observer';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default {
  data() {
    return {
      scrollTop: window.scrollY,
      smoothScroller: null,
      enabled: true,
      scrollerInitialized: false,
      scrollerObserved: false,
      resizeObserver: null
    }
  },
  methods: {
    enableScroll(target = ".main-menu-wrapper") {
      if (this.isDevice) {
        target = document.querySelector('body');

        enableBodyScroll(target, {
          reserveScrollBarGap: true,
        })
      } else {
        if (this.smoothScroller) {
          this.smoothScroller.start()
          this.enabled = true
        }
      }
    },
    disableScroll(target = ".main-menu-wrapper") {
      if (this.isDevice) {
        target = document.querySelector('body');

        disableBodyScroll(target, {
          reserveScrollBarGap: false,
        })
      } else {
        if (this.smoothScroller) {
          this.smoothScroller.stop()
          this.enabled = false
        }
      }
    },
    toggleScroll() {
      if (this.enabled) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
    initSmoothScroller() {
      let self = this

      this.smoothScroller = new LocomotiveScroll({
        el: document.querySelector("[data-scroll-container]"),
        smooth: true,
        scrollFromAnywhere: true,
        tablet: {
          smooth: false
        },
        smartphone: {
          smooth: false
        },
        // tablet: {
        //   smooth: true,
        // },
      })

      this.smoothScroller.on("scroll", (value) => {
        this.scrollTop = value.scroll.y
        ScrollTrigger.update()
      })

      ScrollTrigger.scrollerProxy("[data-scroll-container]", {
        scrollTop(value) {
          return arguments.length ? self.smoothScroller.scrollTo(value, 0, 0) : self.smoothScroller.scroll.instance.scroll.y
        },
        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight
          }
        },
        pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed"
      })

      ScrollTrigger.addEventListener("refresh", () => {
        this.smoothScroller.update()
      })

      ScrollTrigger.refresh()

      this.scrollerInitialized = true
    },
    scrollTo(target, callback, offset = 0) {
      this.smoothScroller.scrollTo(target, {
        duration: 250,
        callback: callback ? callback : null,
        offset: offset
      })
    }
  },
  created() {
    const self = this;

    if (!this.scrollerObserved) {

      this.resizeObserver = new ResizeObserver(function (entries) {
        this.scrollerObserved = true;

        if (!self.smoothScroller) {
          self.initSmoothScroller();
        } else {
          self.smoothScroller.update();
        }
      });
    }
  },
  mounted() {
    if (document.querySelector("[data-scroll-container]")) {
      this.resizeObserver.observe(document.querySelector("[data-scroll-container]"));
    }
  },
  // beforeUpdate() {
  //   if (this.scrollerObserved) {
  //     this.resizeObserver.unobserve(document.querySelector("[data-scroll-container]"))
  //     this.scrollerObserved = false
  //   }

  //   if (this.smoothScroller) {
  //     this.smoothScroller.destroy()
  //     this.scrollerInitialized = false
  //     this.smoothScroller = null
  //   }
  // },
  // updated() {
  //   if (document.querySelector("[data-scroll-container]") && !this.isDevice) {
  //     if (!this.smoothScroller) {
  //       this.initSmoothScroller()
  //     }

  //     this.resizeObserver.observe(document.querySelector("[data-scroll-container]"))
  //     this.scrollerObserved = true
  //   }
  // }
}